var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"vcl-button",class:['primary', 'fill', 'small'],style:(_vm.buttonStyles),attrs:{"type":"button"},on:{"click":_vm.handleSelect}},'button',_vm.attrs,false),_vm.listeners),[(_vm.busy)?_c('VpThinking',{attrs:{"styles":_vm.styles.thinkingStyles}}):_vm._t("default",function(){return [_vm._v(" Button ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }